import React from "react";

interface StripeRow {
  transaction_id: string | number;
  total_amount: number;
  net_amount: number;
  mycia_commission: number;
  created_at: string;
}

interface Props {
  rows: StripeRow[];
}

const StripeDetailTable: React.FC<Props> = ({ rows }) => {
  if (!rows || rows.length === 0) {
    return <p className="text-xs text-gray-500">Nessuna transazione trovata.</p>;
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full text-xs border rounded">
        <thead className="bg-mcia_orange text-white hover:text-black">
          <tr>
            <th className="px-2 py-1 text-left">Transazione ID</th>
            <th className="px-2 py-1 text-left">Totale</th>
            <th className="px-2 py-1 text-left">Importo Netto</th>
            <th className="px-2 py-1 text-left">Commissione MyCIA</th>
            <th className="px-2 py-1 text-left">Data</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((t) => (
            <tr key={String(t.transaction_id)} className="border-t odd:bg-white even:bg-gray-200">
              <td className="px-2 py-1">{t.transaction_id}</td>
              <td className="px-2 py-1">€ {t.total_amount.toFixed(2)}</td>
              <td className="px-2 py-1">{t.net_amount.toFixed(2)}</td>
              <td className="px-2 py-1">€ {t.mycia_commission.toFixed(2)}</td>
              <td className="px-2 py-1">{t.created_at}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default StripeDetailTable;
